import { Link, useLocation } from 'react-router-dom';
import { ChartBarIcon, UserGroupIcon, BuildingStorefrontIcon, MegaphoneIcon, UsersIcon, GlobeAltIcon } from '@heroicons/react/24/outline';

const NavLink = ({ to, icon, children }) => {
    const location = useLocation();
    // Make the link active if the path starts with the 'to' prop
    const isActive = location.pathname.startsWith(to);
    return (
        <Link 
            to={to} 
            className={`flex items-center p-2 rounded transition-colors ${
                isActive ? 'bg-orange-600 text-white' : 'text-gray-300 hover:bg-gray-700 hover:text-white'
            }`}
        >
            {icon}
            {children}
        </Link>
    );
};

const SuperAdminSidebar = () => (
  <aside className="w-64 bg-gray-800 text-white flex flex-col flex-shrink-0">
    <Link to="/" className="p-4 text-2xl font-bold text-center hover:bg-gray-700 transition-colors">
      Saffron ERP
    </Link>
    <nav className="flex-grow p-4 space-y-2">
      <NavLink to="/" icon={<ChartBarIcon className="h-6 w-6 mr-3"/>}>Dashboard</NavLink>
      
      <div className="pt-4">
        <h3 className="px-2 text-xs font-semibold text-gray-400 uppercase tracking-wider">CRM</h3>
        <div className="mt-2 space-y-2">
          {/* Default to the 'businesses' sub-route */}
          <NavLink to="/crm/leads/businesses" icon={<UserGroupIcon className="h-6 w-6 mr-3"/>}>Lead Management</NavLink>
          <NavLink to="/crm/customers/businesses" icon={<BuildingStorefrontIcon className="h-6 w-6 mr-3"/>}>Customer Mngmt</NavLink>
          <NavLink to="/crm/campaigns/businesses" icon={<MegaphoneIcon className="h-6 w-6 mr-3"/>}>Campaigns</NavLink>
        </div>
      </div>
      
      <div className="pt-4">
          <h3 className="px-2 text-xs font-semibold text-gray-400 uppercase tracking-wider">Platform</h3>
          <div className="mt-2 space-y-2">
            <NavLink to="/hrms" icon={<UsersIcon className="h-6 w-6 mr-3"/>}>HRMS</NavLink>
            <NavLink to="/website-cms" icon={<GlobeAltIcon className="h-6 w-6 mr-3"/>}>Website CMS</NavLink>
          </div>
      </div>
    </nav>
  </aside>
);

export default SuperAdminSidebar;